import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArrowUpIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="13px" height="16px" viewBox="0 0 13 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Sensors-Selection-+-Pressure-Sensors-Config."
          transform="translate(-1156.000000, -412.000000)"
          fill={color ?? token.colorBorder}
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(238.000000, 196.000000)">
            <g id="Group-15" transform="translate(365.000000, 46.000000)">
              <g id="up-and-down-copy" transform="translate(553.000000, 170.000000)">
                <path
                  d="M8.12997746,1.6000368 C8.12997746,1.17567504 7.95834029,0.76870568 7.65255555,0.468634779 C7.34693381,0.168579877 6.93226623,0 6.49999484,0 C6.06772345,0 5.65305587,0.168579877 5.34743413,0.468634779 C5.04181239,0.76870568 4.87001223,1.17567504 4.87001223,1.6000368 L4.87001223,10.5377944 L2.7624447,8.46894679 C2.45502998,8.17758008 2.04329637,8.01629637 1.61591493,8.01997646 C1.18853349,8.02349654 0.779733851,8.19182041 0.477535074,8.48846723 C0.175336297,8.78511406 0.00386212626,9.18640329 5.56780674e-05,9.60593294 C-0.00347279551,10.0254626 0.160829452,10.4296319 0.457649286,10.7313988 L5.34759713,15.5315092 C5.65321887,15.8315161 6.06788645,16 6.49999484,16 C6.93226623,16 7.34677081,15.8315161 7.65239255,15.5315092 L12.5423404,10.7313988 C12.8393232,10.4296319 13.0036255,10.0254626 12.9999393,9.60593294 C12.9961276,9.18640329 12.8246534,8.78511406 12.5224546,8.48846723 C12.2202558,8.19182041 11.8114562,8.02349654 11.3840747,8.01997646 C10.9566933,8.01629637 10.5449597,8.17758008 10.237545,8.46894679 L8.12997746,10.5377944 L8.12997746,1.6000368 Z"
                  id="Shape"
                  transform="translate(6.500000, 8.000000) scale(1, -1) translate(-6.500000, -8.000000) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowUpIcon;
